@if (exportMode()) {
	<!-- Export mode: render all items without virtual scrolling -->
	<div class="list-viewport export-mode">
		@for (element of elementen(); track element) {
			<ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: element }"></ng-container>
		} @empty {
			<ng-container *ngTemplateOutlet="emptyTemplate()"></ng-container>
		}
	</div>
} @else {
	<!-- Normal mode: virtual scrolling -->
	<cdk-virtual-scroll-viewport #scroller itemSize="itemSize()" class="list-viewport" [style.max-width]="'100%'">
		<ng-container *cdkVirtualFor="let element of elementen()">
			<ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: element }"></ng-container>
		</ng-container>
		@if (elementen().length === 0 && !loading()) {
			<ng-container *ngTemplateOutlet="emptyTemplate()"></ng-container>
		}
		@if (loading()) {
			<ng-container *ngTemplateOutlet="loaderTemplate()"></ng-container>
		}
	</cdk-virtual-scroll-viewport>
}
